// ImportTab.js
import React, { useState } from 'react';
import Papa from 'papaparse'; // npm install papaparse
import { getToken } from '../../../utils/TokenUtils';
import { API_URL } from '../../../constants/api';

export default function ImportTab({ table }) {
  const [file, setFile] = useState(null);
  const [details, setDetail] = useState(null);

  const [importType, setImportType] = useState('csv'); // default
  const [note, setNote] = useState(
    '📌 CSV Import Instructions:\n- First row = column names (headers)\n- Each following row = data\n- Column names must match table columns.'
  );

  const token = getToken();

  const handleFileTypeChange = (type) => {
    setImportType(type);
    setFile(null); // reset chosen file if type changes

    if (type === 'csv') {
      setNote(
        '📌 CSV Import Instructions:\n- First row = column names (headers)\n- Each following row = data\n- Column names must match table columns.'
      );
    } else {
      setNote(
        '📌 SQL Import Instructions:\n- File must contain valid SQL statements\n- Example: INSERT INTO table_name (col1, col2) VALUES (...)\n- Multiple INSERTs are allowed.'
      );
    }
  };
  // ✅ Handle File Upload
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  // ✅ Import CSV
  const importCSV = async () => {
    if (!file) return alert('Please select a CSV file first!');

    Papa.parse(file, {
      header: true, // use CSV header row as columns
      skipEmptyLines: true,
      complete: async function (results) {
        const rows = results.data; // parsed rows as objects

        try {
          const res = await fetch(`${API_URL}/api/sql/import-csv/${table}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ rows }), // send rows to backend
          });

          // then parse it
          let result;
          try {
            result = await res.json();
            console.log('parsed result:', result);
          } catch (err) {
            console.error('Failed to parse JSON:', err);
            const text = await res.text();
            console.log('raw text response:', text);
          }
          if (res.ok) {
            setDetail(result.details);
            alert(
              `${result.message}, Success: ${result.success}, Failed: ${result.failed}`
            );
          } else {
            alert('Failed to import CSV');
          }
        } catch (err) {
          alert(err);
        }
      },
    });
  };

  // ✅ Import SQL
  const importSQL = async () => {
    if (!file) return alert('Please select a SQL file first!');

    const text = await file.text(); // read file as string

    try {
      const res = await fetch(`${API_URL}/api/sql/import-sql/${table}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/sql',
          Authorization: `Bearer ${token}`,
        },
        body: text, // send raw SQL to backend
      });

      if (res.ok) {
        alert('SQL imported successfully!');
      } else {
        alert('Failed to import SQL');
      }
    } catch (err) {
      alert(err);
    }
  };

  // ✅ Trigger Import
  const handleImport = () => {
    if (importType === 'csv') {
      importCSV();
    } else {
      importSQL();
    }
  };

  return (
    <div>
      <p>
        Import data into <strong>{table}</strong>.
      </p>

      {/* Select type: CSV or SQL */}
      <div className="mb-3">
        <label className="me-3">
          <input
            type="radio"
            value="csv"
            checked={importType === 'csv'}
            onChange={(e) => handleFileTypeChange(e.target.value)}
          />{' '}
          CSV
        </label>
        <label>
          <input
            type="radio"
            value="sql"
            checked={importType === 'sql'}
            onChange={(e) => handleFileTypeChange(e.target.value)}
          />{' '}
          SQL
        </label>
      </div>
      <div
        style={{
          marginTop: '10px',
          padding: '10px',
          border: '1px solid #ccc',
          background: '#f9f9f9',
        }}
      >
        <pre style={{ whiteSpace: 'pre-wrap' }}>{note}</pre>
      </div>

      {/* File Input */}
      <input
        type="file"
        className="form-control mb-3"
        accept={importType === 'csv' ? '.csv' : '.sql'}
        onChange={handleFileChange}
      />

      <button className="btn btn-success" onClick={handleImport}>
        Import {importType.toUpperCase()}
      </button>

      {details && details.length > 0 && (
        <div style={{ marginTop: '20px' }}>
          <h4>Import Results</h4>
          <table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
              marginTop: '10px',
            }}
          >
            <thead>
              <tr style={{ background: '#f4f4f4' }}>
                <th>#</th>
                <th>Name</th>
                <th>Role</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Status</th>
                <th>Error</th>
              </tr>
            </thead>
            <tbody>
              {details.map((r, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{r.row.name}</td>
                  <td>{r.row.role}</td>
                  <td>{r.row.phone}</td>
                  <td>{r.row.email}</td>
                  <td
                    style={{
                      color: r.status === 'success' ? 'green' : 'red',
                      fontWeight: 'bold',
                    }}
                  >
                    {r.status}
                  </td>
                  <td>{r.error || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
